var exports = {
  "Q": "x4ddf2309--7bd7aa--content",
  "q": "x4ddf2309--7bd7aa--footer",
};

module.exports = exports;
